import React from 'react';
import { motion } from 'framer-motion';
import { FileText, CalendarDays, Factory, Truck, Search, Check } from 'lucide-react';
import { useStepCycle } from '../../hooks/useStepCycle';
import { EASE_IN_OUT, EASE_OUT } from '../../utils/motion';
const nodes = [{
  x: 17,
  y: 36,
  label: 'Auftrag',
  icon: FileText
}, {
  x: 39,
  y: 62,
  label: 'Planung',
  icon: CalendarDays
}, {
  x: 61,
  y: 36,
  label: 'Fertigung',
  icon: Factory
}, {
  x: 83,
  y: 62,
  label: 'Versand',
  icon: Truck
}];
export function AnalysisIllustration() {
  const step = useStepCycle(nodes.length + 1, 1300);
  const scanning = step < nodes.length;
  const target = nodes[Math.min(step, nodes.length - 1)];
  const analysed = Math.min(step + 1, nodes.length);
  return <div className="absolute inset-0" data-id="element-1" data-mp="2r0yp5f8fmrsy">
      <div className="absolute top-6 left-6 bg-white rounded-full px-4 py-2 text-sm font-medium text-primary shadow-sm" data-id="element-2" data-mp="u6kcf36kigsg">
        Ist-Analyse vor Ort
      </div>

      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" data-id="element-3" data-mp="p8isyh58cfgg">
        <polyline points={nodes.map(n => `${n.x},${n.y}`).join(' ')} fill="none" stroke="#284756" strokeOpacity={0.25} strokeWidth={2} strokeDasharray="6 6" vectorEffect="non-scaling-stroke" data-id="element-4" data-mp="343d3ezc1f6ic" />
      </svg>

      {nodes.map((node, i) => {
      const done = i <= step;
      const Icon = node.icon;
      return <div key={node.label} className="absolute -translate-x-1/2 -translate-y-1/2" style={{
        left: `${node.x}%`,
        top: `${node.y}%`
      }} data-id="element-5" data-mp="3mtuqooe3p9wb" data-mpi={i}>
            <div className={`relative w-24 h-24 xl:w-28 xl:h-28 bg-white rounded-2xl shadow-sm border-2 flex flex-col items-center justify-center gap-2 transition-colors duration-200 ${done ? 'border-accent' : 'border-transparent'}`} style={{
          transitionDelay: done ? '450ms' : '0ms'
        }} data-id="element-6" data-mp="3e1sux3ez8hsd">
              <Icon className="w-7 h-7 text-primary" data-id="element-7" data-mp="k8674zulzmvj" />
              <span className="text-sm font-semibold text-primary" data-id="element-8" data-mp="f91xk83rvn4o">
                {node.label}
              </span>
              <motion.span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-accent flex items-center justify-center" initial={false} animate={{
            opacity: done ? 1 : 0,
            scale: done ? 1 : 0.6
          }} transition={{
            duration: 0.2,
            ease: EASE_OUT,
            delay: done ? 0.45 : 0
          }} data-id="element-9" data-mp="a9p95ix967zz">
                <Check className="w-3.5 h-3.5 text-primary" strokeWidth={3} data-id="element-10" data-mp="3npwnyo3dvf1v" />
              </motion.span>
            </div>
          </div>;
    })}

      <motion.div className="absolute pointer-events-none" initial={false} animate={{
      left: `${target.x}%`,
      top: `${target.y}%`,
      opacity: scanning ? 1 : 0
    }} transition={{
      duration: 0.45,
      ease: EASE_IN_OUT
    }} data-id="element-11" data-mp="3drqp6fcvip18">
        <div className="-mt-20 ml-6 w-14 h-14 rounded-full bg-white shadow-lg border-2 border-primary flex items-center justify-center" data-id="element-12" data-mp="1t8woh75n4cm1">
          <Search className="w-6 h-6 text-primary" strokeWidth={2.5} data-id="element-13" data-mp="1y9kpmlnl29tz" />
        </div>
      </motion.div>

      <div className="absolute bottom-6 right-6 bg-primary text-white rounded-full px-4 py-2 text-sm font-medium" data-id="element-14" data-mp="2361eji2lws84">
        {analysed} / {nodes.length} Prozessschritte aufgenommen
      </div>
    </div>;
}